import { snakeCase } from "lodash";

const buildUrlWithParams = (
  url: string,
  params: {
    [key: string]: any;
  },
) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    const keySnakeCase = snakeCase(key);

    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(keySnakeCase, v));
    } else {
      searchParams.append(keySnakeCase, value);
    }
  });

  const searchParamsString = searchParams.toString();

  if (!searchParamsString) {
    return url;
  }

  return `${url}?${searchParamsString}`;
};

export default buildUrlWithParams;
